import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useFiscalYear } from "@/context/FiscalYearContext";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { CalendarBlank } from "@phosphor-icons/react";

const Ctx = createContext({ month: null, setMonth: () => {} });
export const usePeriod = () => useContext(Ctx);
const MON = ["Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "Jan", "Feb", "Mar"];

export const fyMonths = (fy) => {
  const y = Number(String(fy).slice(0, 4));
  return MON.map((m, i) => { const yr = i < 9 ? y : y + 1; const mm = String(((i + 3) % 12) + 1).padStart(2, "0"); return { value: `${yr}-${mm}`, label: `${m} ${String(yr).slice(2)}` }; });
};
export const monthAbbr = (ym) => (ym ? MON[(Number(ym.slice(5, 7)) + 8) % 12] : null);
export const periodLabel = (month, fy) => (month ? (fyMonths(fy).find((m) => m.value === month)?.label || month) : `FY ${fy}`);

export const PeriodProvider = ({ children }) => {
  const { fy } = useFiscalYear();
  const [month, setMonth] = useState(() => localStorage.getItem("dash_month") || null);
  useEffect(() => { if (month) localStorage.setItem("dash_month", month); else localStorage.removeItem("dash_month"); }, [month]);
  useEffect(() => { if (month && !fyMonths(fy).some((m) => m.value === month)) setMonth(null); }, [fy]); // eslint-disable-line react-hooks/exhaustive-deps
  const v = useMemo(() => ({ month, setMonth }), [month]);
  return <Ctx.Provider value={v}>{children}</Ctx.Provider>;
};

export function PeriodPicker() {
  const { fy } = useFiscalYear();
  const { month, setMonth } = usePeriod();
  return (
    <Select value={month || "fy"} onValueChange={(v) => setMonth(v === "fy" ? null : v)}>
      <SelectTrigger className="h-9 w-44 rounded-md text-xs font-mono" data-testid="period-picker"><CalendarBlank size={14} className="mr-1.5 shrink-0" /><SelectValue /></SelectTrigger>
      <SelectContent>
        <SelectItem value="fy" data-testid="period-option-fy">Full FY {fy}</SelectItem>
        {fyMonths(fy).map((m) => <SelectItem key={m.value} value={m.value} data-testid={`period-option-${m.value}`}>{m.label}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}
